import { useMemo, useState } from 'react'
import InsumoHttp from '../../../../services/api/https/insumos/insumo.http'

export const FIELDS_NAMES = {
  INSUMO_NAME: 'name',
  UNI_MOVIMENTACAO: 'unidadeMovimentacao',
}
export const LOADING_MESSAGES = {
  NONE: 'none',
  SAVE: 'Salvando as informações . . . ',
}

const INIT_STATE = {
  loadingMessage: LOADING_MESSAGES.NONE,
  errorMessage: null,
  insumo: null,
  savedInsumo: null,
}

export default function useCadastroInsumoModal() {
  const [state, setState] = useState({ ...INIT_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: LOADING_MESSAGES.NONE,
          savedInsumo: null,
        }))
      },

      saveInsumo(insumo) {
        if (insumo.id) {
          InsumoHttp.updateInsumo(insumo)
            .then(savedInsumo => {
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOADING_MESSAGES.NONE,
                savedInsumo,
              }))
            })
            .catch(e => {
              setState(prevState => ({
                ...prevState,
                errorMessage: e,
                loadingMessage: LOADING_MESSAGES.NONE,
              }))
            })
        } else {
          InsumoHttp.insertInsumo(insumo)
            .then(savedInsumo => {
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOADING_MESSAGES.NONE,
                savedInsumo,
              }))
            })
            .catch(e => {
              setState(prevState => ({
                ...prevState,
                errorMessage: e,
                loadingMessage: LOADING_MESSAGES.NONE,
              }))
            })
        }
      },

      // Events
      onStart(selectedInsumo) {
        setState(prevState => ({ ...prevState, insumo: selectedInsumo }))
      },

      onFormChange(field, value) {
        setState(prevState => {
          prevState.insumo[field] = value
          return { ...prevState }
        })
      },

      onCheckboxClick(tp) {
        setState(prevState => {
          const item = prevState.insumo.allowedTps.find(aTp => aTp.id === tp.id)
          if (item) {
            item.active = !item.active
          }
          return {
            ...prevState,
            insumo: {
              ...prevState.insumo,
              allowedTps: [...prevState.insumo.allowedTps],
            },
          }
        })
      },

      onBtnSalvar() {
        setState(prevState => ({ ...prevState, loadingMessage: LOADING_MESSAGES.SAVE }))
      },
    }
  }, [])

  return { state, localDispatch }
}
